// Must exceed TriviaStats::SHORT_ANSWER_SYNC_TIMEOUT plus request overhead.
export const SHORT_ANSWER_DEADLINE_MS = 13000
// Recovery only persists/finalizes the answer; it never calls OpenAI.
export const SHORT_ANSWER_RECOVERY_DEADLINE_MS = 5000
